import React from 'react';
import { Heading, Flex, Text, Box } from 'rebass';
import { graphql } from "gatsby";
import BorderWrapper from "../borderWrapper";
import Image from "../image";
import { Image as RebassImage } from 'rebass';
import { pathOr, path } from "ramda";
import Button from "../button";
import { getLinkWithComponent, useGetFieldsByName } from '../../utils';
import Container from "./container";
import theme from "../../gatsby-plugin-theme-ui";
import useSlidePose from "../../hooks/useSlidePose";
import { blurredConfig, descriptionConfig } from "../posed";
import posed from "react-pose";
import { useColorMode } from "theme-ui";

const wrapperStyles = {
	position: 'absolute',
	zIndex: -1,
	left: 0,
	top: 0,
	width: "100%",
	height: "100%",
};

const BlurInBox = posed(Box)(blurredConfig);
const Content = posed(Box)(descriptionConfig);

const Citation = ({ children, image, borderWidth = 3, sx = {}, pose, ...props }) => (
	<Heading as="div" p={5} {...props} sx={{ ...sx, position: 'relative' }}>
		{children}
		{image ? <BlurInBox pose={pose} sx={{...wrapperStyles}}>
			<RebassImage
				src={image}
				height="100%"
				width="100%"
		 		sx={{
					clipPath: `polygon(0% 0%, 0% 100%, ${borderWidth}px 100%, ${borderWidth}px ${borderWidth}px, calc(100% - ${borderWidth}px) ${borderWidth}px, calc(100% - ${borderWidth}px) calc(100% - ${borderWidth}px), ${borderWidth}px calc(100% - ${borderWidth}px), ${borderWidth}px 100%, 100% 100%, 100% 0%)`
		 		}}
		/></BlurInBox> : (
			<Box
				sx={{
					...wrapperStyles,
					borderColor: 'text',
					borderStyle: 'solid',
					borderWidth: `${borderWidth}px`,
				}}
			/>)}
	</Heading>
);

const ModuleCitation = ({ module, state, index }) => {
	const [colorMode] = useColorMode();
	const { linkDescription, link, descriptionString } = useGetFieldsByName(['linkDescription', 'link', 'descriptionString'], module, colorMode);
	const image = pathOr(null, ['relationships', 'image', 'relationships', 'file', 'localFile', 'childImageSharp', 'fluid'], module);
	const pose = useSlidePose(state, index);

	return (
		<BorderWrapper
			flexDirection={['column-reverse', null, 'row']}
			alignItems={['stretch', null, 'flex-start']}
			sx={{ width: '100%' }}
		>
			<Flex
				height="100%"
				width="100%"
				sx={{ flexGrow: 1, zIndex: 1 }}
				bg="bg"
			>
				<Container justifyContent="flex-start" containerProps={{ width: "100%"}}>
					<Flex
						width={['100%', null, 0.5]}
						flexDirection="column"
						alignItems="center"
						justifyContent="center"
					>
						<Citation
							image={path(['base64'], image)}
							sx={{
								position: 'relative',
								left: [0, 0, theme.space[6] / 2, theme.space[7] / 2],
								width: ['100%', null, `calc(100% + ${theme.space[6]}px)`, `calc(100% + ${theme.space[7]}px)`],
								lineHeight: 1.3,
								textAlign: ['center', null, 'left']
							}}
							pr={[null, null, 6, 7]}
							p={[4, null, 5]}
							fontSize={[4, 5, null, 6]}
							height="auto"
							pose={pose}
						>
							<Content pose={pose}>{descriptionString}</Content>
						</Citation>
						<Flex alignItems="center" flexDirection={['column', null, 'row']} justifyContent="space-between" width="100%" mt={[4, null, 5]} pl={[null, null, 5]}>
							{linkDescription ? <Text fontSize={0} sx={{ fontWeight: 700 }} mr={[null, null, 2]} mb={[2, null, 0]}>{linkDescription}</Text> : null}
							{link ? <Button {...getLinkWithComponent(link.uri)}>{link.title}</Button> : null}
						</Flex>
					</Flex>
				</Container>
			</Flex>
			{image ? (
				<Image
					width={['100%', null, 0.45]}
					height={[null, null, '100%']}
					sx={{ flexShrink: [null, null, 0] }}
					fluid={image}
				/>) : null}
		</BorderWrapper>
	)
};

export default ModuleCitation;

export const query = graphql`
    fragment moduleCitationFragment on paragraph__module_citation {
        internal {
            type
        }
        linkDescription: field_link_description
        linkDescription_dark: field_dark_link_description
        link: field_link_2 {
            title
            uri
        }
        link_dark: field_dark_link_2 {
            title
            uri
        }
        descriptionString: field_description_brut
        descriptionString_dark: field_dark_description_brut
        relationships {
            image: field_image {
                relationships {
                    file: field_media_image {
                        localFile {
                            childImageSharp {
                                fluid(maxWidth: 960, quality: 80) {
                                    ...GatsbyImageSharpFluid_withWebp
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
